import {TPMEventBO} from "./TPMEventBO";
import {ASync} from "../PA.Core/Basic/ASync";
import {TPMEventSpend} from "./TPMEventBO.ITPMEventSpend";
import {IPolicy} from "../PA.Core/PA.Core.IF.Policy";
import {BehaviorSubject} from "rxjs";
import {WB_EventTypeRow, WB_TPM_EventSpendTypeRow} from "../PA.Core/PAdbSchemaRows";
import {UserSecurityService} from "../PA.Security.Services/UserSecurityService";
import {IUsrContext} from "../PA.Core/PA.Core.IF.User";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import * as _ from "lodash";
import {Role_TPM_Event_Approver, Role_TPM_Event_Editor} from "../PA.Core/Security/Roles";
import {PaymentMethod_OffInvoice} from "../PA.TPM.Core/TPM.Constants";
import {DateUtils} from "../PA.Core/Basic/Dates";


export class TPMEventBOStandardSpendPolicy
  implements IPolicy {
  _tpmEventSpend: TPMEventSpend
  _tpmEvent: TPMEventBO
  _evtType: WB_EventTypeRow
  _spendType: WB_TPM_EventSpendTypeRow


  _isApprover: boolean
  _isEditor: boolean

  _isClosedOrCancelled: boolean
  _isPostApproval: boolean
  _isPreApproval: boolean

  _isSpendClosedOrCancelled: boolean
  _isSpendPostApproval: boolean
  _isSpendPreApproval: boolean
  _isSpendInitial: boolean

  _isOffInvoice: boolean

  _isLoaded: boolean
  _PolicyChanged: BehaviorSubject<IPolicy>


  constructor(tpmEventSpend: TPMEventSpend) {
    this._tpmEventSpend = tpmEventSpend
    this._tpmEvent = tpmEventSpend.TPMEventBO
    this._evtType = this._tpmEvent.WB_TPMEvent.WB_EventTypeRow
    this._spendType = tpmEventSpend.TPMEventSpendRow.WB_TPM_EventSpendTypeRow
    this._isApprover = false
    this._isEditor = false
    this._isClosedOrCancelled = false
    this._isPostApproval = false
    this._isPreApproval = false

    this._isSpendClosedOrCancelled = false
    this._isSpendPostApproval = false
    this._isSpendPreApproval = false
    this._isSpendInitial = false

    this._isOffInvoice = false
    this._isLoaded = false
    this._PolicyChanged = new BehaviorSubject<IPolicy>(this)
  }


  get OnLoadComplete(): Promise<void> {
    const self = this

    if (self._isLoaded) {
      return ASync.resolve()
    }

    self.ResetPolicyState()

    return ASync.resolve()

  }

  ResetPolicyState() {
    const self = this

    self._tpmEvent.OnLoadComplete
      .then((ignore) => {

        let currentState = self._tpmEvent.PrimaryWorkflowProcessor.CurrentState
        self._isClosedOrCancelled = currentState.StatusTypeClosed || currentState.StatusTypeCancelled
        self._isPostApproval = currentState.StatusTypeIsPostApproval
        self._isPreApproval = currentState.StatusTypeIsPreApproval

        let spendCurrentState = self._tpmEventSpend.PrimaryWorkflowProcessor.CurrentState
        self._isSpendClosedOrCancelled = spendCurrentState.StatusTypeClosed || spendCurrentState.StatusTypeCancelled
        self._isSpendPostApproval = spendCurrentState.StatusTypeIsPostApproval
        self._isSpendPreApproval = spendCurrentState.StatusTypeIsPreApproval
        self._isSpendInitial = spendCurrentState.StatusTypeInitial

        self._isOffInvoice = (this._tpmEventSpend.TPMEventSpendRow.cif.PAYMENT_METHOD == PaymentMethod_OffInvoice)

        return UserSecurityService.getPlanMangementList()
      })
      .then((arrWB_PlanMgmt_IDs) => {
        let usrContext: IUsrContext = PAEnvironment.getValue(PAEnvironment.UserContext)

        if (_.includes(arrWB_PlanMgmt_IDs, self._tpmEvent.WB_TPMEvent.WB_PlanRow.cif.WB_PLNMGMT_ID) && usrContext) {
          self._isEditor = usrContext.hasRoleId(Role_TPM_Event_Editor, self._tpmEvent.WB_TPMEvent.cif.WB_CUST_ID_PLANNING)
          self._isApprover = usrContext.hasRoleId(Role_TPM_Event_Approver, self._tpmEvent.WB_TPMEvent.cif.WB_CUST_ID_PLANNING)
        } else {
          self._isApprover = false
          self._isEditor = false
        }
        self._isLoaded = true
        self._PolicyChanged.next(self)
      })
      .catch((err) => {
        self._isApprover = false
        self._isEditor = false
        self._PolicyChanged.next(self)
      })

  }

  get bIsApprover(): boolean {
    return this._isApprover
  }

  get bIsEditor(): boolean {
    return this._isEditor
  }

  get bIsClosedOrCancelled(): boolean {
    return this._isClosedOrCancelled
  }

  get bIsSpendClosedOrCancelled(): boolean {
    return this._isSpendClosedOrCancelled
  }

  get bIsSpendInitial(): boolean {
    return this._isSpendInitial
  }

  get bIsPostApproval(): boolean {
    return this._isPostApproval
  }

  get bIsSpendPostApproval(): boolean {
    return this._isSpendPostApproval
  }

  get bIsPreApproval(): boolean {
    return this._isPreApproval
  }

  get bIsSpendPreApproval(): boolean {
    return this._isSpendPreApproval
  }

  get bIsOffInvoice(): boolean {
    return this._isOffInvoice
  }


  // Add Editability/ Visibility Properties for all the Elements of a Tactic.
  get bNameEditable(): boolean {
    return this.bIsEditor && !this.bIsSpendClosedOrCancelled
  }

  get bNameVisible(): boolean {
    return this._spendType.bNameShowInd
  }

  get bWorkflowVisible(): boolean {
    return this._spendType.bWorkflowShowInd
  }


  get bFundTypeEditable(): boolean {
    return this.bIsEditor && !this.bIsSpendClosedOrCancelled
  }

  get bFundTypeVisible(): boolean {
    return this._spendType.bFundTypeShowInd
  }


  get bInStoreDatesEditable(): boolean {
    return this.bIsEditor && !this.bIsSpendClosedOrCancelled && this._spendType.cif.INSTOREDATES_POLICY == "UserInput"
  }

  get bInStoreDatesVisible(): boolean {
    return this._spendType.bInStoreDatesShowInd
  }

  get bDistributionDatesEditable(): boolean {
    return this.bIsEditor && !this.bIsSpendClosedOrCancelled && this._spendType.cif.DISTRIBUTIONDATES_POLICY == "UserInput"
  }

  get bDistributionDatesVisible(): boolean {
    return this._spendType.bDistributionDatesShowInd
  }

  private get bShipmentDatesBaseEditable(): boolean {
    return this.bIsEditor && !this.bIsSpendClosedOrCancelled && this._spendType.cif.SHIPMENTDATES_POLICY == "UserInput"
  }


  get bShipmentStartDateEditable(): boolean {
    let bBaseEditRights = this.bShipmentDatesBaseEditable
    if (this.bIsSpendPostApproval && this.bIsOffInvoice && bBaseEditRights) {
      let startDate = this._tpmEventSpend.TPMEventSpendRow.ShipmentStartDt
      if (_.isDate(startDate)) {
        if (DateUtils.isLessThan(startDate, DateUtils.today)) {
          return false
        } else {
          return true
        }
      } else {
        return true  // No Date
      }
    }

    return bBaseEditRights
  }

  get bShipmentEndDateEditable(): boolean {
    let bBaseEditRights = this.bShipmentDatesBaseEditable
    if (this.bIsSpendPostApproval && this.bIsOffInvoice && bBaseEditRights) {
      let endDate = this._tpmEventSpend.TPMEventSpendRow.ShipmentEndDt
      if (_.isDate(endDate)) {
        if (DateUtils.isLessThan(endDate, DateUtils.today)) {
          return false
        } else {
          return true
        }
      } else {
        return true  // No Date
      }
    }

    return bBaseEditRights
  }


  get bShipmentDatesVisible(): boolean {
    return this._spendType.bShipmentDatesShowInd
  }

  get bOrderDatesEditable(): boolean {
    return this.bIsEditor && !this.bIsSpendClosedOrCancelled && this._spendType.cif.ORDERDATES_POLICY == "UserInput"
  }

  get bOrderDatesVisible(): boolean {
    return this._spendType.bOrderDatesShowInd
  }

  get bCommentsEditable(): boolean {
    return (this.bIsEditor || this.bIsApprover) && !this.bIsSpendClosedOrCancelled
  }


  get bCommentsVisible(): boolean {
    return this._spendType.bCommentsShowInd
  }


  get bRateAmountEditable(): boolean {
    if ((!this.bIsEditor) || this.bIsSpendClosedOrCancelled) {
      return false
    }

    if (this.bIsOffInvoice && this.bIsSpendPostApproval) {
      // Check if the event has started..
      let startDate = this._tpmEventSpend.TPMEventSpendRow.ShipmentStartDt
      if (_.isDate(startDate) && DateUtils.isLessThan(startDate, DateUtils.today)) {
        return false
      }
    }

    return true
  }

  get bRateAmountHeaderVisible(): boolean {
    return this._spendType.cif.RATE_LEVEL == 'Header'
  }

  get bRateAmountProductGroupVisible(): boolean {
    return this._spendType.cif.RATE_LEVEL == 'ProductGroup'
  }

  get bRateAmountProductVisible(): boolean {
    return this._spendType.cif.RATE_LEVEL == 'Product'
  }


  get bRateUOMEditable(): boolean {
    return this.bIsEditor && this.bIsSpendPreApproval && !this.bIsSpendClosedOrCancelled
  }

  get bRateUOMVisible(): boolean {
    return this._spendType.bRateUOMShowInd
  }

  get bRateBasisEditable(): boolean {
    return this.bIsEditor && this.bIsSpendPreApproval && !this.bIsSpendClosedOrCancelled
  }

  get bRateBasisVisible(): boolean {
    return this._spendType.bRateBasisShowInd
  }

  get bRedemptionRateEditable(): boolean {
    return this.bIsEditor && !this.bIsSpendClosedOrCancelled  // && this.bIsSpendPreApproval
  }

  get bRedemptionRateHeaderVisible(): boolean {
    return this._spendType.cif.REDEMPTIONRATE_LEVEL == 'Header'
  }

  get bRedemptionRateProductGroupVisible(): boolean {
    return this._spendType.cif.REDEMPTIONRATE_LEVEL == 'ProductGroup'
  }


  get bPaymentMethodEditable(): boolean {
    return this.bIsEditor && this.bIsSpendPreApproval && !this.bIsSpendClosedOrCancelled
  }

  get bPaymentMethodVisible(): boolean {
    return this._spendType.bPaymentMethodShowInd
  }

  get bPlannedSpendVisible(): boolean {
    return this._spendType.bPlannedSpendShowInd
  }

  get bApprovedSpendVisible(): boolean {
    return this._spendType.bApprovedSpendShowInd && !this.bIsPreApproval
  }

  get bActualSpendVisible(): boolean {
    return this._spendType.bActualSpendShowInd && !this.bIsSpendPreApproval
  }

  get bPaidInFullVisible(): boolean {
    return this._spendType.bPaidInFullShowInd && !this.bIsSpendPreApproval
  }

  get bPaidInFullEditable(): boolean {
    return this.bIsEditor && this.bIsSpendPostApproval && !this.bIsSpendClosedOrCancelled
  }


  get bThirdPartyVisible(): boolean {
    return this._spendType.bThirdPartyShowInd
  }

  get bProductGroupSummaryVisible(): boolean {
    return this._spendType.bProductGroupSummaryShowInd
  }

  get bProductGroupSummaryEditable(): boolean {
    return this.bIsEditor && !this.bIsSpendClosedOrCancelled
  }


  get bProductSummaryVisible(): boolean {
    return this._spendType.bProductSummaryShowInd
  }

  get bProductSummaryEditable(): boolean {
    return this.bIsEditor && !this.bIsSpendClosedOrCancelled
  }


  get bProductMainGridVisible(): boolean {
    return this._spendType.cif.MAINTABGRID == 'Product'
  }

  get bProductGroupMainGridVisible(): boolean {
    return this._spendType.cif.MAINTABGRID == 'ProductGroup'
  }

  get bProductIncludeEditable(): boolean {
    let bBaseCase = this.bIsEditor && !this.bIsSpendClosedOrCancelled
    if (!bBaseCase) {
      return false
    }

    if (this.bIsSpendInitial) {
      return true
    }

    if (this._tpmEventSpend.TPMEventSpendRow.cif.PAYMENT_METHOD == PaymentMethod_OffInvoice) {
      let startDate = this._tpmEventSpend.TPMEventSpendRow.ShipmentStartDt
      if (_.isDate(startDate) && DateUtils.isLessThan(startDate, DateUtils.today)) {
        return false
      }
    }

    return true
  }

  get bProductIncludeVisible(): boolean {
    return this._spendType.bProductIncludeShowInd
  }

  get bProductGroupIncludeEditable(): boolean {
    let bBaseCase = this.bIsEditor && !this.bIsSpendClosedOrCancelled
    if (!bBaseCase) {
      return false
    }

    if ((this._tpmEventSpend.TPMEventSpendRow.cif.PAYMENT_METHOD == PaymentMethod_OffInvoice) && this.bIsSpendPostApproval) {
      let startDate = this._tpmEventSpend.TPMEventSpendRow.ShipmentStartDt
      if (_.isDate(startDate) && DateUtils.isLessThan(startDate, DateUtils.today)) {
        return false
      }
    }

    return true
  }

  get bProductGroupIncludeVisible(): boolean {
    return this._spendType.bProductGroupIncludeShowInd
  }

  get bPaymentsVisible(): boolean {
    return this._spendType.bPaymentsShowInd && (this.bIsSpendClosedOrCancelled || this.bIsSpendPostApproval)
  }


  get bOffInvoiceLogVisible(): boolean {
    return this._spendType.bOffInvoiceLogShowInd && this.bIsOffInvoice && (this.bIsSpendClosedOrCancelled || this.bIsSpendPostApproval)
  }

  get bProductVolBasisVisible(): boolean {
    return this._spendType.bProductVolBasisShowInd
  }

  get bIndirectCustomerVisible(): boolean {
    return this._spendType.bIndirectCustomerShowInd
  }


  get PolicyChanged(): BehaviorSubject<IPolicy> {
    return this._PolicyChanged
  }

  get bProductBUOMQtyEditable(): boolean {
    return this.bRateAmountEditable && this._tpmEvent.WB_TPMEvent.WB_PlanRow.WB_PlanTypeRow.cif.DISPLAY_HANDLING_METHOD_ID == 'Legacy'
  }

  get bProductDisplayQtyEditable(): boolean {
    return this.bRateAmountEditable && this._tpmEvent.WB_TPMEvent.WB_PlanRow.WB_PlanTypeRow.cif.DISPLAY_HANDLING_METHOD_ID == 'Legacy'
  }

}


